import type { Theme } from "@mui/material/styles";
import type { AppSharedPageStyles } from "../types";

export function buildSharedPageStyles(_theme: Theme): AppSharedPageStyles {
  return {
    alertMarginBottom2: { mb: 2 },
    alertMarginBottom1_5: { mb: 1.5 },
    alertCompactPy: { py: 0.5 },
    alertCompactPyQuarter: { py: 0.25 },
    alertMarginTopHalf: { mt: 0.5 },
    alertMarginBottom1: { mb: 1 },
    alertMarginTop2: { mt: 2 },
    statChipStack: { mt: 0.5 },
    iconMarginRightHalf: { mr: 0.5 },
    captionBlock: { display: "block" },
    captionBlockLineHeight: { display: "block", lineHeight: 1.4 },
    flexShrinkZero: { flexShrink: 0 },
    minWidthZero: { minWidth: 0 },
    overflowAuto: { overflow: "auto" },
    tableActionsCell: { width: 72, minWidth: 72 },
    tableMinWidth720: { minWidth: 720 },
    tableCellWordBreak: { maxWidth: 280, wordBreak: "break-word" },
    tableCellEllipsis: { maxWidth: 240, overflow: "hidden", textOverflow: "ellipsis" },
    sectionHeaderRow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      mb: 1.25,
      gap: 1,
    },
    errorMenuItem: { color: "error.main" },
    errorListItemIcon: { color: "error.main" },
    buttonMinWidth120: { minWidth: 120 },
    buttonMarginRight1: { mr: 1 },
    toggleButtonTextNone: { textTransform: "none" },
    loadingStackPy10: { py: 10 },
    chipPendingApproval: { height: 22, fontSize: 11 },
    relativePosition: { position: "relative" },
    promptFullscreenButton: {
      position: "absolute",
      top: 8,
      right: 8,
      backgroundColor: "background.paper",
      "&:hover": {
        backgroundColor: "action.hover",
      },
    },
    monospaceDialogInput: {
      "& .MuiOutlinedInput-root": {
        fontFamily: "monospace",
        fontSize: "14px",
        lineHeight: 1.6,
      },
      "& textarea": {
        resize: "vertical",
      },
    },
    centeredLoadingBox: {
      minHeight: "50vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    pageLoadingCenter: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: 400,
    },
    brandLogoHeight: {
      height: 64,
      maxWidth: 240,
      width: "auto",
      objectFit: "contain",
    },
    brandLogoContained: {
      height: 64,
      maxWidth: "100%",
      width: "auto",
      objectFit: "contain",
    },
    authFormMaxWidth: { width: "100%", maxWidth: 420 },
    authHeaderStack: { mb: 3 },
    sidebarContentStack: { p: 2, flex: 1, minHeight: 0 },
    responsiveTitleAlign: { textAlign: { xs: "center", md: "left" }, wordBreak: "break-word" },
    captionMarginTopHalf: { mt: 0.5 },
  };
}
